import { Component, OnInit } from '@angular/core';
import { LoginserviceService } from '../services/services/loginservice.service';
import { NavigationExtras, Router } from '@angular/router';
import { ViewChild } from '@angular/core';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.css']
})
export class NavigationComponent implements OnInit {


  @ViewChild('sidebar', { static: false }) sidebar;

  userBO: any = {};
  userrolerightsColl: any = [];
  userView: any = {};
  companyType: string = "";

  isallowance: boolean = false;
  isbonustype: boolean = false;
  isdeduction: boolean = false;
  isexpensetype: boolean = false;
  isloantype: boolean = false;
  ispaymode: boolean = false;
  ispaytype: boolean = false;
  ispayrollgrp: boolean = false;
  isreimbursetype: boolean = false;
  iswpsgroup: boolean = false;
  isbank: boolean = false;
  isbankbranch: boolean = false;


  isdepartment: boolean = false;
  isdesignation: boolean = false;
  isemptype: boolean = false;
  isgrade: boolean = false;
  islocation: boolean = false;
  isrelievetype: boolean = false;
  issponser: boolean = false;
  iscontracttype: boolean = false;
  iscategory: boolean = false;


  isgender: boolean = false;
  ismaritialstatus: boolean = false;
  isrelationship: boolean = false;
  isreligion: boolean = false;
  issalution: boolean = false;
  isemployee: boolean = false;

  isleavetype: boolean = false;
  isovertimetype: boolean = false;
  isholidays: boolean = false;
  isleavepolicy: boolean = false;

  isassettype: boolean = false;
  isasset: boolean = false;
  isincidenttype: boolean = false;
  ismemotype: boolean = false;
  isskills: boolean = false;
  isaccomtype: boolean = false;
  isstatus: boolean = false;
  ishiresource: boolean = false;
  isalerttype: boolean = false;

  iscompany: boolean = false;
  isbranch: boolean = false;
  isuserrole: boolean = false;
  isuser: boolean = false;
  isdoctype: boolean = false;

  isexpense: boolean = false;
  isincident: boolean = false;
  isbonus: boolean = false;
  isreimburse: boolean = false;
  ismemo: boolean = false;
  isfine: boolean = false;
  istraining: boolean = false;
  ispayadv: boolean = false;
  istransfer: boolean = false;
  isovertime: boolean = false;
  isloan: boolean = false;
  isleave: boolean = false;
  isannualleave: boolean = false;
  isleavesalary: boolean = false;
  ispayadj: boolean = false;
  isinsurance: boolean = false;
  ispayroll: boolean = false;
  isotherrequest: boolean = false;
  isempdetailschange: boolean = false;
  isshorttermpay: boolean = false;
  isairticket: boolean = false;
  isfinalsettlement: boolean = false;

  isapporvals: boolean = false;

  isreport: boolean = false;
 

  issettingsmenu: boolean = false;

  constructor(public loginService: LoginserviceService, public router: Router) {
    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.userrolerightsColl = this.loginService.userrolerightsColl;
    this.loginService.serviceloginChange.subscribe((value) => {
      this.userView = value
      if (this.userView.userBO) {
        this.userBO = this.userView.userBO
      }

      this.fnCheckMenu();

    });
  }


  ngOnInit() {
    this.loginService.fnGetUserRoleList();
  }

  fnCheckMenu() {
    if (this.loginService.fnCheckUserRoleAll('Allowance')) {
      this.isallowance = true;
    }
    if (this.loginService.fnCheckUserRoleAll('BonusType')) {
      this.isbonustype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Deduction')) {
      this.isdeduction = true;
    } if (this.loginService.fnCheckUserRoleAll('Expensetype')) {
      this.isexpensetype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('LoanType')) {
      this.isloantype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('PayMode')) {
      this.ispaymode = true;
    }
    if (this.loginService.fnCheckUserRoleAll('PayType')) {
      this.ispaytype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('PayrollGroup')) {
      this.ispayrollgrp = true;
    }
    if (this.loginService.fnCheckUserRoleAll('ReimburseType')) {
      this.isreimbursetype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('WpsGroup')) {
      this.iswpsgroup = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Bank')) {
      this.isbank = true;
    }
    if (this.loginService.fnCheckUserRoleAll('BankBranch')) {
      this.isbankbranch = true;
    }


    if (this.loginService.fnCheckUserRoleAll('Department')) {
      this.isdepartment = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Designation')) {
      this.isdesignation = true;
    }
    if (this.loginService.fnCheckUserRoleAll('EmpType')) {
      this.isemptype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Grade')) {
      this.isgrade = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Location')) {
      this.islocation = true;
    }
    if (this.loginService.fnCheckUserRoleAll('RelieveType')) {
      this.isrelievetype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Sponser')) {
      this.issponser = true;
    }
    if (this.loginService.fnCheckUserRoleAll('ContractType')) {
      this.iscontracttype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Category')) {
      this.iscategory = true;
    }


    if (this.loginService.fnCheckUserRoleAll('Gender')) {
      this.isgender = true;
    }
    if (this.loginService.fnCheckUserRoleAll('MaritalStatus')) {
      this.ismaritialstatus = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Relationship')) {
      this.isrelationship = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Religion')) {
      this.isreligion = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Salution')) {
      this.issalution = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Employee')) {
      this.isemployee = true;
    }



    if (this.loginService.fnCheckUserRoleAll('LeaveType')) {
      this.isleavetype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('OverTimeType')) {
      this.isovertimetype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Holidays')) {
      this.isholidays = true;
    }
    if (this.loginService.fnCheckUserRoleAll('LeavePolicy')) {
      this.isleavepolicy = true;
    }


    if (this.loginService.fnCheckUserRoleAll('AssetType')) {
      this.isassettype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Asset')) {
      this.isasset = true;
    }
    if (this.loginService.fnCheckUserRoleAll('IncidentType')) {
      this.isincidenttype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('MemoType')) {
      this.ismemotype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Skills')) {
      this.isskills = true;
    }
    if (this.loginService.fnCheckUserRoleAll('AccomType')) {
      this.isaccomtype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Status')) {
      this.isstatus = true;
    }
    if (this.loginService.fnCheckUserRoleAll('HiResource')) {
      this.ishiresource = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Alerttype')) {
      this.isalerttype = true;
    }


    if (this.loginService.fnCheckUserRoleAll('Company')) {
      this.iscompany = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Branch')) {
      this.isbranch = true;
    }
    if (this.loginService.fnCheckUserRoleAll('UserRole')) {
      this.isuserrole = true;
    }
    if (this.loginService.fnCheckUserRoleAll('User')) {
      this.isuser = true;
    }
    if (this.loginService.fnCheckUserRoleAll('DocType')) {
      this.isdoctype = true;
    }



    if (this.loginService.fnCheckUserRoleAll('Expense')) {
      this.isexpense = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Incident')) {
      this.isincident = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Bonus')) {
      this.isbonus = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Reimburse')) {
      this.isreimburse = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Memo')) {
      this.ismemo = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Fine')) {
      this.isfine = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Training')) {
      this.istraining = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Payadvance')) {
      this.ispayadv = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Transfer')) {
      this.istransfer = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Overtime')) {
      this.isovertime = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Loan')) {
      this.isloan = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Leave')) {
      this.isleave = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Annualleave')) {
      this.isannualleave = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Leavesalary')) {
      this.isleavesalary = true;
    }
    if (this.loginService.fnCheckUserRoleAll('PayAdjustment')) {
      this.ispayadj = true;
    }


    if (this.loginService.fnCheckUserRoleAll('Payroll')) {

      this.ispayroll = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Approvals')) {
      this.isapporvals = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Report')) {

      this.isreport = true;
    }
    // if (this.loginService.fnCheckUserRoleAll('Promotion')) {

    //   this.ispromotion = true;
    // }
    if (this.loginService.fnCheckUserRoleAll('OtherRequest')) {
      this.isotherrequest = true;
    }
    if (this.loginService.fnCheckUserRoleAll('EmpDetailsChange')) {
      this.isempdetailschange = true;
    }
    if (this.loginService.fnCheckUserRoleAll('ShorttermPay')) {
      this.isshorttermpay = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Insurance')) {
      this.isinsurance = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Airticket')) {
      this.isairticket = true;
    }
    if (this.loginService.fnCheckUserRoleAll('FinalSettlement')) {
      this.isfinalsettlement = true;
    }
  }
  

  fnMenuClick(form) {
    this.router.navigate([form]).then(() => {

      // document.getElementById('compact_submenuSidebar').classList.value = "submenu-sidebar";

    });

  }




  fnSettingsMenuClick(menu) {
    let navigationExtras: NavigationExtras = {
      queryParams: {
        'menu': menu,
      }
    }



    this.router.navigate(['/SettingsMenu'], navigationExtras).then(() => {


    });

  }



  // fnFocusOutSliderBar(){

  //   document.getElementById('compact_submenuSidebar').classList.value = "submenu-sidebar";
  // }
}
